<template>
  <div>
    <PageHeader title="جزییات مدیریت سفارشات" :items="pageHeaderItems" />
    <div v-if="detail.transactions && detail.transactions.length && detail.transactions[0].bankName" class="card px-3 py-2">
      <div class="d-flex justify-content-end">
        <b-button :disabled="!isBasketCancel" @click="$bvModal.show('cancelBasket')" variant="danger">کنسل کردن سبد</b-button>
      </div>
    </div>
    <div class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-1 class="order-header" @click="orderArrowUp = !orderArrowUp">
          <div class="header">اطلاعات اولیه سفارش</div>
          <i :class="`fas fa-chevron-${orderArrowUp ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-1" class="collapse-content" visible>
          <div>
            <table class="w-100">
              <tbody>
                <tr>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">کد سفارش :</div>
                      <div class="left-titles">{{ detail.orderId || 'ــــــ' }}</div>
                    </div>
                  </td>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">شماره موبایل کاربر :</div>
                      <div class="left-titles">{{ detail.phoneNumber }}</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">شماره فاکتور :</div>
                      <div class="left-titles">{{ detail.orderNumber || 'ــــــ' }}</div>
                    </div>
                  </td>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">نام کاربر :</div>

                      <div class="left-titles">{{ detail.fullName }}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-collapse>
      </div>
    </div>

    <div v-if="['False', 'false'].includes($route.query.isCancel)" class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-2 class="order-header" @click="orderArrowUp = !orderArrowUp">
          <div class="header">اطلاعات مالی سفارش</div>
          <i :class="`fas fa-chevron-${orderArrowUp ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-2" class="collapse-content" visible>
          <div>
            <table class="w-100">
              <tbody>
                <tr>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">مبلغ کل سبد خرید :</div>
                      <div class="tag-info price">{{ Commafy(detail.total) || '0' }}</div>
                    </div>
                  </td>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">مبلغ کل تخفیفات عمومی سبد خرید:</div>
                      <div class="tag-info price">{{ Commafy(detail.totalDiscount) || '0' }}</div>
                    </div>
                  </td>
                </tr>

                <tr>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">مبلغ کد تخفیف / کد معرف در سبد خرید :</div>
                      <div class="tag-info price">{{ Commafy(detail.totalGift) || '0' }}</div>
                      <div>{{ detail.discountCode && detail.inviterFullName ? detail.inviterFullName : detail.discountCode }}</div>
                    </div>
                  </td>
                  <td class="w-50">
                    <div class="d-flex gap-3">
                      <div class="right-titles">مبلغ کل پرداخت شده :</div>

                      <div class="tag-info price" style="color: rgba(52, 195, 143, 1)">{{ Commafy(detail.totalPrice) || '0' }}</div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </b-collapse>
      </div>
    </div>

    <div v-if="['False', 'false'].includes($route.query.isCancel)" class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-3 class="order-header" @click="orderArrowUp = !orderArrowUp">
          <div class="header">نحوه پرداخت سفارش</div>
          <i :class="`fas fa-chevron-${orderArrowUp ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-3" class="collapse-content" visible>
          <div>
            <div v-if="detail.transactions" class="w-100 d-flex justify-content-between align-items-center flex-wrap">
              <div v-for="(item, index) in detail.transactions" :key="index" :class="['w-50', { order_divider: detail.transactions.length > 1 }]">
                <div :class="['m-3 d-flex gap-4 align-items-center']">
                  <div>{{ `${item.bankName ? 'پرداخت با اسنپ‌پی' : transactionTypeCheck[item.transationType]} :` }}</div>
                  <div class="gap-3">
                    <span>
                      {{ Commafy(item.amount) || '0' }}
                    </span>

                    <span>{{ item.transationType === 2 ? 'دادکوین' : 'تومان' }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="py-3 mx-2" v-else>
              <div class="d-flex align-items-center gap-2 mx-3">
                <div>{{ detail.transactions && detail.transactions.length && detail.transactions[0].bankName ? 'پرداخت با اسنپ‌پی' : 'درگاه پرداخت' }}</div>

                <div class="price">{{ Commafy(detail.totalPrice) || '0' }}</div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <div v-if="detail.installments && ['False', 'false'].includes($route.query.isCancel)" class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-4 class="order-header" @click="orderArrowUp = !orderArrowUp">
          <div class="header">مدیریت اقساط سفارش</div>
          <i :class="`fas fa-chevron-${orderArrowUp ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-4" class="collapse-content" visible>
          <div>
            <div v-for="(item, index) in detail.installments" :key="index">
              <div class="p-4">
                <h5>{{ item.title }}</h5>

                <div style="border-bottom: 1px solid rgba(206, 212, 218, 1)">
                  <div class="d-flex justify-content-between">
                    <div class="d-flex gap-3 my-4">
                      <div>کل مبلغ قسط بسته :</div>

                      <div class="price">{{ Commafy(item.totalPrice) }}</div>
                    </div>

                    <div class="d-flex gap-3 my-4">
                      <div>بدهی کاربر :</div>

                      <div class="price" style="color: rgba(244, 106, 106, 1)">{{ Commafy(item.totalDebt) || '0' }}</div>
                    </div>
                  </div>
                </div>

                <div v-for="(ins, idx) in item.items" :key="idx" class="my-3">
                  <div class="d-flex gap-4 align-items-center">
                    <div>{{ `مبلغ قسط ${idx + 1} : ` }}</div>

                    <div :class="['price', { success_price: ins.status === 2 }]">{{ Commafy(ins.price) || '0' }}</div>

                    <div>
                      <div>
                        <div v-show="ins.status === 2" class="success_transaction">
                          <span>پرداخت شده</span>
                        </div>
                      </div>
                    </div>

                    <div v-if="ins.date" style="width: 150px">{{ `تاریخ پرداخت : ${convertDate(ins.date) || ''}` }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <div class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-5 class="order-header" @click="productArrowUp = !productArrowUp">
          <div class="header">جزییات سفارشات ثبت شده</div>
          <i :class="`fas fa-chevron-${productArrowUp ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-5" visible>
          <div v-for="(item, index) in detail.orderItems" :key="index">
            <div :class="['products', { _products: index === detail.orderItems.length - 1 }]">
              <b-row>
                <b-col cols="12" md="3" class="image">
                  <img :src="item.image" />
                </b-col>
                <b-col cols="12" md="8" class="contents">
                  <div class="d-flex justify-content-between align-items-center">
                    <div :class="['w-50', { 'w-100': ['False', 'false'].includes($route.query.isCancel) }]">
                      <div class="content-title">{{ item.title }}</div>
                      <div class="tag">
                        <div class="tag-title">کد درس :</div>
                        <div class="tag-info">{{ item.productId }}</div>
                      </div>
                      <div class="d-flex">
                        <div class="tag">
                          <div class="tag-title">نوع درس :</div>
                          <div class="tag-info">{{ item.typeOfProduct }}</div>
                        </div>

                        <div class="tag">
                          <div class="tag-title">نوع خرید :</div>
                          <div class="tag-info">{{ detail.installments ? 'اقساطی' : 'نقدی' }}</div>
                        </div>
                      </div>
                    </div>

                    <b-button
                      v-if="['False', 'false'].includes($route.query.isCancel)"
                      :class="['align-self-start cancel_button', { disable: item.isCancel || isSingleSnapPayOrder || !isBasketCancel }]"
                      @click="onCancelOrder(item.id)"
                      style="width: 150px"
                      >کنسل کردن سفارش
                    </b-button>

                    <div class="d-flex flex-wrap gap-4 align-self-start">
                      <p v-if="['True', 'true'].includes($route.query.isCancel)" style="font-size: 13px; font-weight: 500; color: rgba(244, 106, 106, 1); margin: 0">
                        سفارش توسط ادمین کنسل شده است.
                      </p>

                      <p v-if="['True', 'true'].includes($route.query.isCancel)" style="font-size: 13px; font-weight: 500; color: rgba(244, 106, 106, 1); margin: 0">
                        {{ `  مربوط به شماره سفارش : ${detail.parentOrderId}` }}
                      </p>
                    </div>
                  </div>

                  <div class="d-flex flex-wrap">
                    <div class="tag">
                      <div class="tag-title">قیمت قبل تخفیف عمومی :</div>
                      <div class="tag-info price">
                        {{ $route.query.isInstallment === 'True' ? Commafy(+item.totalPrice) || '0' : Commafy(+item.price + +item.discount) || '0' }}
                      </div>
                    </div>

                    <div class="tag">
                      <div class="tag-title">مبلغ تخفیف عمومی :</div>
                      <div class="tag-info price">{{ Commafy(item.discount) || '0' }}</div>
                    </div>

                    <div style="color: rgba(24, 59, 167, 1)" v-if="['True', 'true'].includes($route.query.isCancel)" class="tag">
                      <div style="color: rgba(24, 59, 167, 1); font-size: 18px; font-weight: 500" class="tag-title">مبلغ عودت :</div>
                      <div style="color: rgba(24, 59, 167, 1); font-size: 18px; font-weight: 500" class="tag-info price">{{ Commafy(detail.totalPrice) || '0' }}</div>
                    </div>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-collapse>
      </div>
    </div>

    <div v-if="['True', 'true'].includes($route.query.isCancel)" class="card px-4 py-3">
      <div class="order-detail">
        <div v-b-toggle.collapse-6 class="order-header" @click="cancelPaymentDetail = !cancelPaymentDetail">
          <div class="header">جزییات عودت وجه</div>
          <i :class="`fas fa-chevron-${cancelPaymentDetail ? 'down' : 'up'}`"></i>
        </div>
        <b-collapse id="collapse-6" visible>
          <div class="my-3">
            <UploadBox
              :cloud="true"
              accept="image/*,.xlsx,.pdf,.docx,.pptx"
              @fileBoxData="uploadedFile($event)"
              :imageHeight="220"
              :imageFile="detail.url"
              :fileType="detail.urlType"
              :fileTitle="detail.urlName"
              :filesLength="1"
              placeholder="عکس یا فایل واریز مبلغ عودت شده را بارگزاری نمایید "
            />
          </div>

          <div class="textArea">
            <text-area-input v-model="detail.description" title="علت انصراف" />
          </div>
        </b-collapse>
      </div>

      <div class="p-3 py-2 d-flex gap-3 justify-content-end">
        <b-button @click="$router.push('/list/skilluporders')">انصراف</b-button>
        <b-button :disabled="(!detail.description && !detail.url && !secondUrl) || loading" @click="cancelOrder" variant="primary" style="width: 120px">
          <div :class="{ 'd-flex gap-2 align-items-center': loading }">
            <span>ثبت اطلاعات</span>
            <i v-if="loading" class="fas fa-spinner fa-spin"></i>
          </div>
        </b-button>
      </div>
    </div>

    <b-modal id="cancelOrder" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="../../../assets/images/checked1.svg" />
        </div>

        <div class="error-title text-center">ادمین گرامی در نظر داشته باشید چنانچه سفارش کاربر کنسل گردد امکان بازگشت آن وجود ندارد در صورت تایید به کنسل کلیک نمایید.</div>

        <div v-if="!isSnappay" class="mt-3">
          <BaseText :maxlength="2000" v-model="rejectPrice" placeholder="وارد کردن مبلغ مورد نظر (تومان)" />
        </div>

        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" style="background-color: white; color: rgba(78, 78, 86, 1) !important" block @click="$bvModal.hide('cancelOrder'), (amount = '')">
              بازگشت به سفارشات
            </b-button>
            <b-button class="ms-2 col-6 cancel_order" @click="onCanceledOrder" block>انصراف کاربر از خرید</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <b-modal id="cancelBasket" no-close-on-esc hide-footer centered headerClass="p-3 border-bottom-0" header-close-variant="dark" cancel-title>
      <div class="error-wrapper">
        <div class="mb-4 text-center">
          <img src="../../../assets/images/checked1.svg" />
        </div>

        <div class="error-title text-center">ادمین گرامی در نظر داشته باشید چنانچه سفارش کاربر کنسل گردد امکان بازگشت آن وجود ندارد در صورت تایید به کنسل کلیک نمایید.</div>

        <div class="mt-3 float-right w-100">
          <div class="d-flex align-items-center justify-content-center">
            <b-button class="col-6" style="background-color: white; color: rgba(78, 78, 86, 1) !important" block @click="$bvModal.hide('cancelBasket')">
              بازگشت به سفارشات
            </b-button>
            <b-button class="ms-2 col-6 cancel_order" @click="cancelBasket" block>انصراف کاربر از خرید</b-button>
          </div>
        </div>
      </div>
    </b-modal>
    <toast :error="error" :showToast="showToast" :title="message" />
  </div>
</template>
<script>
import PageHeader from '../../layoutComponents/page-header.vue'
import skillUpOrderProvider from '../../../services/skillUp/order.js'
import moment from 'jalali-moment'
import BaseText from '../../common/form/formModules/BaseText.vue'
import Toast from '../../common/Toast.vue'
import UploadBox from '../../common/form/formModules/UploadBox.vue'
import TextAreaInput from '../../common/form/formModules/TextAreaInput.vue'

export default {
  components: { PageHeader, BaseText, Toast, UploadBox, TextAreaInput },
  data() {
    return {
      pageHeaderItems: [
        { text: 'داشبورد', href: '/' },
        { text: 'جزییات مدیریت سفارشات', active: true },
      ],
      rejectPrice: '',
      detail: {},
      description: '',
      secondUrl: '',
      secondUrlName: '',
      secondUrlType: '',
      amount: '',
      orderArrowUp: false,
      productArrowUp: false,
      loading: false,
      cancelPaymentDetail: false,
      orderItemId: '',
      showToast: false,
      error: true,
      message: '',
      transactionTypeCheck: {
        0: 'درگاه پرداخت',
        1: 'کیف پول تومانی',
        2: 'کیف پول دادکوینی',
      },
    }
  },
  async created() {
    await this.fetchOrderItems()
  },
  watch: {
    rejectPrice(c) {
      this.rejectPrice = this.rejectPrice.toString()
      this.rejectPrice = c.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
  },
  computed: {
    isBasketCancel() {
      return this.detail.orderItems.find((item) => item.isCancel === false)
    },
    isSingleSnapPayOrder() {
      const filter = this.detail.orderItems.filter((item) => !item.isCancel)
      if (this.isSnappay && filter.length === 1) {
        return true
      }

      return false
    },
    isSnappay() {
      return !!(this.detail.transactions && this.detail.transactions.length && this.detail.transactions[0].bankName)
    },
  },
  methods: {
    uploadedFile($event) {
      if (Array.isArray($event) && !$event.length) {
        this.secondUrl = ''
        this.secondUrlName = ''
        this.secondUrlType = ''
        this.detail.url = ''
        this.detail.urlName = ''
        this.detail.urlType = ''
        return
      }
      if (Array.isArray($event) && $event.length) {
        this.secondUrl = $event[0]?.url
        this.secondUrlName = $event[0]?.name
        this.secondUrlType = $event[0]?.name.split('.')[$event[0].name.split('.').length - 1]
        return
      }
    },

    async cancelOrder() {
      try {
        this.loading = true
        await skillUpOrderProvider.cancelOrder({
          id: this.$route.params.id,
          description: this.detail.description,
          url: this.secondUrl || this.detail.url,
          urlType: this.secondUrlType || this.detail.urlType,
          urlName: this.secondUrlName || this.detail.urlName,
          isSnappay: this.isSnappay,
        })
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.message = 'تغییرات با موفقیت ذخیره شد.'
          this.error = false
          this.fetchOrderItems()
        })
      } catch (error) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.message = 'مشکلی پیش آمده است لطفا دوباره تلاش کنید.'
          this.error = true
        })
      } finally {
        this.loading = false
      }
    },
    async cancelBasket() {
      try {
        this.loading = true
        this.$bvModal.hide('cancelBasket')
        await skillUpOrderProvider.cancelBasket(this.$route.params.id)
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.message = 'سبد خرید با موفقیت کنسل شد.'
          this.error = false
          this.fetchOrderItems()
        })
      } catch (error) {
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.message = 'مشکلی پیش آمده است لطفا دوباره تلاش کنید.'
          this.error = true
        })
      } finally {
        this.loading = false
      }
    },
    async fetchOrderItems() {
      const req = await skillUpOrderProvider.fetchOrderItems({
        id: +this.$route.params.id,
        isInstallment: ['True', 'true'].includes(this.$route.query.isInstallment) ? true : false,
        isCancel: ['True', 'true'].includes(this.$route.query.isCancel) ? true : false,
      })
      this.detail = req.data.data.output
    },
    onCancelOrder(id) {
      this.orderItemId = ''
      this.$bvModal.show('cancelOrder')
      this.amount = ''
      this.orderItemId = id
    },
    async onCanceledOrder() {
      try {
        let _amount = this.rejectPrice.replace(/,/g, '')

        await skillUpOrderProvider.cancelOrderItem({
          orderItemId: this.orderItemId,
          isInstallment: ['True', 'true'].includes(this.$route.query.isInstallment) ? true : false,
          price: _amount ? +_amount : undefined,
          isSnappay: this.isSnappay,
        })
        this.$bvModal.hide('cancelOrder')
        this.fetchOrderItems()
        this.showToast = false
        this.$nextTick(() => {
          this.showToast = true
          this.error = false
          this.message = 'درخواست شما با موفقیت ثبت شد.'
        })
      } catch (error) {
        console.log(error)
        this.$bvModal.hide('cancelOrder')
        this.fetchOrderItems()
      }
    },
    convertDate(date) {
      if (date) {
        let finalTime = moment(date).locale('fa').format('YYYY/M/D')
        return finalTime
      }
    },
    Commafy(number) {
      if (number) {
        let floated = parseFloat(number)
        var str = floated.toString().split('.')
        if (str[0].length > 0) {
          str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1.')
          return str.join('.')
        }
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.order-detail {
  border: 1px solid #f0f1f1;
  border-radius: 5px;
}

::v-deep .mainCloud {
  margin-right: 11px;
  justify-content: flex-start;
  width: 108%;
}
.order-header {
  display: flex;
  justify-content: space-between;
  padding: 10px 8px;
  position: relative;
  background: #f8f9fa;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.0520833);
  cursor: pointer;

  i {
    font-size: 10px;
    position: absolute;
    top: 15px;
    left: 24px;
    color: #555555;
  }
}
.header {
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  color: #444444;
}

.right {
  width: 150px;
  display: inline-block;
}

.right-titles {
  font-weight: 400;
  font-size: 13px;
  line-height: 21px;
  text-align: right;
  color: #495057;
  // margin: 20px;
}

.left {
  display: inline-block;
}

.left-titles {
  // margin: 20px;
  font-weight: 500;
  font-size: 14px;
  line-height: 23px;
  text-align: right;
  color: #555555;
  position: relative;
  // top: 5px;
}

// ::v-deep .file_cloud {
//   width: auto;
// }

.image {
  margin: 20px;
  img {
    width: 100%;
    height: 192px;
    border-radius: 5px;
  }
}

.content-title {
  font-weight: 500;
  font-size: 16px;
  line-height: 26px;
  color: #4a4a4a;
  margin-bottom: 24px;
}

.tag {
  display: flex;
  margin-bottom: 20px;
  margin-left: 4%;
  .tag-title {
    font-weight: 400;
    font-size: 16px;
    line-height: 26px;
    color: #979797;
  }
  .tag-info {
    font-weight: 400;
    font-size: 16px !important;
    line-height: 26px;
    color: #4a4a4a;
    margin-right: 10px;
  }
}

.contents {
  margin: 20px -20px 20px 10px;
}

.price {
  &::after {
    content: 'تومان';
    margin-right: 5px;
    font-size: 14px;
    font-weight: 100;
  }
}

.line {
  height: 1px;
  background: #ced4da;
  margin: 0 20px;
  display: block !important;
}

table tbody tr td:first-child {
  border: 1px solid rgba(206, 212, 218, 1);
  padding: 15px;
  border-top: none;
  border-right: none;
}

.textArea {
  margin: 22px 13px;
}

table tbody tr td:nth-child(2) {
  border: 1px solid rgba(206, 212, 218, 1);
  padding: 15px;
  border-top: none;
  border-left: none;
}

.order_divider {
  border: 1px solid rgba(206, 212, 218, 1);
  border-top: none;
  border-left: none;
}

.success_price {
  color: rgba(52, 195, 143, 1);
}

.success_transaction {
  border: 1px solid rgba(52, 195, 143, 1);
  color: rgba(52, 195, 143, 1);
  background-color: rgba(52, 195, 143, 0.15);
  padding: 6px 9px;
  border-radius: 25px;
}

.cancel_button {
  width: 100px;
  background-color: rgba(244, 106, 106, 0.33);
  color: rgba(244, 106, 106, 1) !important;
  border-color: rgba(244, 106, 106, 0.33) !important;
}

.cancel_button:focus {
  box-shadow: none !important;
}

.cancel_button:active {
  background-color: rgba(244, 106, 106, 0.33);
  color: rgba(244, 106, 106, 1) !important;
  border-color: rgba(244, 106, 106, 0.33) !important;
}

.cancel_order {
  background-color: rgba(244, 106, 106, 1);
  border-color: rgba(244, 106, 106, 1) !important;
}

::v-deep .row {
  width: 109% !important;
}

.products {
  width: 95%;
  margin: 0 auto;
  border-bottom: 1px solid #ced4da;
}

._products {
  border-bottom: none;
}

.disable {
  background: rgba(184, 183, 183, 0.3) !important;
  color: rgba(85, 85, 85, 0.38) !important;
  pointer-events: none;
  border-color: rgba(184, 183, 183, 0.3) !important;
}

::v-deep .disableInput {
  color: black !important;
}
</style>
